// Utility to determine if Amplitude should be initialized
import { LDClient, LDFlagSet } from 'launchdarkly-react-client-sdk';
import { LDFeatureFlagEnum } from 'tools/feature-flags/launchdarkly-flags';

export function shouldInitializeAmplitude(
  amplitudeInitialized: boolean,
  flags: LDFlagSet,
  ldClient: LDClient | null,
): boolean {
  return (
    !amplitudeInitialized &&
    flags[LDFeatureFlagEnum.ENABLE_AMPLITUDE_GUIDES] != null &&
    !!ldClient?.getContext()?.email
  );
}
